export const handleChunkLoadError = error => {
  const errPattern = /Loading chunk (\d)+ failed/g
  const isChunkError = error.message.match(errPattern)
  if (isChunkError) {
    window.location.reload()
  }
}
